<div class="app-page__container" (contextmenu)="disableContextMenu($event)">
  <div class="app-page__sidebar">
    <app-desktop-side-bar />
  </div>
  <div class="app-page__content-holder">
    <router-outlet></router-outlet>
  </div>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.2)" size="medium" color="#000" type="ball-spin-clockwise-fade" [fullScreen]="true">
</ngx-spinner>

<ngx-spinner bdColor="rgba(51,51,51,0.2)" size="medium" color="#000" type="ball-spin-clockwise-fade" [fullScreen]="true" [name]="'paymentLoading'">
  <span class="app-page__loading-text">{{ "webPos.WaitingForPayment" | translate }}</span>
</ngx-spinner>
